export enum EUserStatus {
  사용 = 1,
  정지 = 2,
  휴직 = 3,
  퇴사 = 4,
  전출 = 5
}
